import { render, staticRenderFns } from "./PotentialClients.vue?vue&type=template&id=09ec62b6&scoped=true"
import script from "./PotentialClients.vue?vue&type=script&lang=js"
export * from "./PotentialClients.vue?vue&type=script&lang=js"
import style0 from "./PotentialClients.vue?vue&type=style&index=0&id=09ec62b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec62b6",
  null
  
)

export default component.exports